const KeenSlider = window.KeenSlider

const { getOffsetTop } = window.BAO.Utils
const { setInitialised, useDots } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveScroller()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 901px)': {
            disabled: true,
          },
        },
      },
      [setInitialised(), useDots(this.els?.dot?.elements)],
    )
  }

  moveScroller () {
    if (!window.BAO.MediaBreakpoints.isMd || this.els.slide.elements.length < 2) { return }

    const slidesEl = this.els.slides.element

    const animationDuration = 0

    const cardSize = parseFloat(this.dataset.total)

    const amountToMoveX = cardSize - 150

    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this)
    const elementEndPoint =
      getOffsetTop(this) + elementHeight - window.innerHeight

    if (this.lastKnownY <= elementStartPoint) {
      setTimeout(() => {
        slidesEl.style.transform = `translate3d(0vw, 0px, 0px)`
      }, animationDuration)

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      setTimeout(() => {
        slidesEl.style.transform = `translate3d(-${amountToMoveX}vw, 0px, 0px)`
      }, animationDuration)

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountX = amountToMoveX * scrollYAsAPercentageOfJourney

    setTimeout(() => {
      slidesEl.style.transform = `translate3d(-${transformAmountX}vw, 0px, 0px)`
    }, animationDuration)
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
